import { ConfirmationModal } from './ConfirmationModal/ConfirmationModal';
import type { ReactElement } from 'react';
import { cloneElement, useState } from 'react';

type InputChangeHandler = (...args: unknown[]) => void;
type InputBlurHandler = (...args: unknown[]) => void;

interface ChildProps {
  onSelect?: InputChangeHandler;
  onChange?: InputChangeHandler;
  onBlur?: InputBlurHandler;
  preventDefault?: boolean;
}

export interface InputChangeConfirmationWrapperProps {
  text: string;
  actionToConfirm: () => void;
  hasToConfirm: boolean;
  children: ReactElement<ChildProps>;
}

export const InputChangeConfirmationWrapper = ({
  hasToConfirm,
  children,
  text,
  actionToConfirm,
}: InputChangeConfirmationWrapperProps) => {
  const [isConfirmationModalVisible, setIsConfirmationModalVisible] = useState<boolean>(false);
  const [onSelectAction, setOnSelectAction] = useState<() => void>();
  const [onChangeAction, setOnChangeAction] = useState<() => void>();
  const [onBlurAction, setOnBlurAction] = useState<() => void>();

  const childOnChange = (...args: unknown[]) => {
    if (hasToConfirm) {
      setIsConfirmationModalVisible(true);

      if (children.props.onChange) {
        setOnChangeAction(() => () => children.props.onChange && children.props.onChange(...args));
      }

      if (children.props.onBlur) {
        setOnBlurAction(() => () => children.props.onBlur && children.props.onBlur(...args));
      }

      return;
    }

    children.props.onChange && children.props.onChange(...args);
  };

  const childOnSelect = (...args: unknown[]) => {
    if (hasToConfirm) {
      setIsConfirmationModalVisible(true);

      if (children.props.onSelect) {
        setOnSelectAction(() => () => children.props.onSelect && children.props.onSelect(...args));
      }

      return;
    }

    children.props.onSelect && children.props.onSelect(...args);
  };

  return (
    <>
      {cloneElement(children, {
        onChange: children.props.onChange && childOnChange,
        onSelect: children.props.onSelect && childOnSelect,
        preventDefault: hasToConfirm,
      })}
      <ConfirmationModal
        text={text}
        isVisible={isConfirmationModalVisible}
        onConfirm={() => {
          actionToConfirm();

          onSelectAction && onSelectAction();
          onChangeAction && onChangeAction();
          onBlurAction && onBlurAction();
        }}
        onClose={() => {
          setIsConfirmationModalVisible(false);
          setOnChangeAction(undefined);
        }}
      />
    </>
  );
};
